const checkLinkAndAppendLanguage = link => {
  const containsLangFolder = /^\/(es|fr|de)(($)|(\/.*))$/;
  if (typeof window !== 'undefined' && window.location && window.location.pathname.match(containsLangFolder)) {
    if (window.location.pathname.match(/^\/fr(($)|(\/.*))$/) && !link.match(/^\/fr(($)|(\/.*))$/)) {
      return `/fr${link}`;
    }
    if (window.location.pathname.match(/^\/es(($)|(\/.*))$/) && !link.match(/^\/es(($)|(\/.*))$/)) {
      return `/es${link}`;
    }
    if (window.location.pathname.match(/^\/de(($)|(\/.*))$/) && !link.match(/^\/de(($)|(\/.*))$/)) {
      return `/de${link}`;
    }
  }
  return link;
};

const generateNewLanguageUrl = (link, newLang) => {
  if (!window || !window.location) {
    return link;
  }
  const containsLangFolder = /\/(es|fr|de)(\/|$)/;
  const cleanUrl = link.replace(containsLangFolder, '');
  if (newLang == '/en') {
    newLang = '';
  }
  const newLink = `${newLang}/${cleanUrl}${window.location.search}`;
  return newLink.replace(/([^:]\/)\/+/g, '$1');
};

export { checkLinkAndAppendLanguage, generateNewLanguageUrl };
